import heic2any from "heic2any";
import { useEffect, useState } from "react";

const HeicPreview = ({ url, alt, className }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let objectUrl;

    const convert = async () => {
      try {
        const res = await fetch(url);
        const heicBlob = await res.blob();

        const jpgBlob = await heic2any({
          blob: heicBlob,
          toType: "image/jpeg",
          quality: 0.8,
        });

        objectUrl = URL.createObjectURL(jpgBlob);
        setPreviewUrl(objectUrl);
      } catch (err) {
        console.error("HEIC conversion failed", err);
      } finally {
        setLoading(false);
      }
    };

    convert();

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  if (loading) {
    return (
      <div className="w-28 h-24 flex items-center justify-center text-xs text-gray-500">
        Converting…
      </div>
    );
  }

  if (!previewUrl) {
    return (
      <div className="w-28 h-24 flex items-center justify-center text-xs text-red-500">
        Preview failed
      </div>
    );
  }

  return <img src={previewUrl} alt={alt} className={className} />;
};

export default HeicPreview;
